import { render, staticRenderFns } from "./ViewCourses.vue?vue&type=template&id=a42e0e16&"
import script from "./ViewCourses.vue?vue&type=script&lang=js&"
export * from "./ViewCourses.vue?vue&type=script&lang=js&"
import style0 from "./ViewCourses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports